import NeedsService from "./needs.service";
import PrintAndCopyService from "./print.and.copy.service";
import ErrorService from "./error.service";
import $ from "jquery";
import moment from "moment-timezone";
import WinnersService from "./chart/winners.service";
import GoogleService from "./google.service";
import AlertService from "./alert.service";
const EMPTY_CELL = "--";
var novalue = "--";
class TableService {
  companyColorList = [];
  moatMapping = [
    { shortName: "Upstart", longName: "Upstart Power" },
    { shortName: "Brand", longName: "Brand Perception" },
    { shortName: "Time", longName: "Time Multiplier" },
    { shortName: "Network", longName: "Network Effect" },
    { shortName: "Routine", longName: "Routine Reliance" },
    { shortName: "Lock-In", longName: "Switching Lock-In" },
    { shortName: "Lock-Out", longName: "Channel Lock-Out" },
    { shortName: "Skill", longName: "Economies of Skill" },
    { shortName: "Scale", longName: "Economies of Scale" },
    { shortName: "Design", longName: "Design Dominance" },
    { shortName: "Value", longName: "Value Chain" }
  ];
  getReportTableContentByTable(reportTableId) {
    let copyOfTable = $("#" + reportTableId).clone();
    copyOfTable.find(".title-and-table-left").remove();
    return copyOfTable
        .wrapAll("<div>")
        .parent()
        .html();
  }  
  getTableData(table){
		try{
      let rowData = table.rows().data().toArray()
      let columnData = [];
      let initialColumnData = table.settings().init().columns;
      for (let index = 0; index < initialColumnData.length; index++) {
        let title = initialColumnData[index].title;
        if (typeof title == "undefined"){
          title = initialColumnData[index].sName;
        }
        columnData.push(title);
        
      }    
      let tableData = {
        rows: rowData,
        columns: columnData,
        companyColorList: this.companyColorList
      }
      return JSON.stringify(tableData);
    } catch (err) {
      ErrorService.logException("TableService.getTableData", err, "chart");
    }
  }  
  getEmptyCell(){
    return EMPTY_CELL;
  }
  nonEmptyAsc(a, b){
    let x = a;
    let y = b;

    if (x == novalue && y != novalue) {
      return -1;
    } else if (x != novalue && y == novalue) {
      return 1;
    } else if (x == novalue && y == novalue) {
      return 0;
    } else if (x != novalue && y != novalue) {
      x = parseFloat(a);
      y = parseFloat(b);

      return x < y ? -1 : x > y ? 1 : 0;
    }

  }
  nonEmptyDesc(a, b){
    let x = a;
    let y = b;

    if (x == novalue && y != novalue) {
      return 1;
    } else if (x != novalue && y == novalue) {
      return -1;
    } else if (x == novalue && y == novalue) {
      return 0;
    } else if (x != novalue && y != novalue) {
      x = parseFloat(a);
      y = parseFloat(b);

      return x < y ? 1 : x > y ? -1 : 0;
    }

  }
  getDateColumn(name) {
    return {
      data: name,
      type: "date",
      name: name,
      width: "7rem",
      render: function(data, type, row) {
        return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY");
      }
    };
  }
  getActiveColumn(name) {
    return {
      data: "active",
      name: "status",
      width: "6rem",
      render: function(data, type, row) {
        var statusMap = { N: { label: "Deactive", style: "warning" }, Y: { label: "Active", style: "success" } };
        if (type === "display") {
          return "<p class='m-0 p-0' style='width: 4rem;'><span class='badge badge-" + statusMap[data].style + "'>" + statusMap[data].label + "</span></p>";
        } else {
          return data;
        }
      }
    };
  }
  getTableButtons(vm, dataContainerId, insightModalIdOverride, reportPageTypeNameOverride,isSavedCard = true, filename = "",displayProfileStrengthLegend = false) {
    let percentageColumns = new Set();
    let cellDecimals = {};   // key = row_col  → decimals
    let cellTypes = {};      // key = row_col  → 'num' | 'percent' | 'txt'
    let columnMaxLength = {};   // custom col width tracking
    let visibleColumns = [];
    let exportColMap = {}; 
    
    let customRowIdx = 0;
    let totalColumns = 0;
    totalColumns = $(`#${dataContainerId}`).find('thead th').length;

    let buttonConfiguration = {
      buttons: [
        {
          text: "<img class='dt-image-button' src='/img/chart-headers/camera-duotone.png'>",
          className: "btn",
          titleAttr: "Take snapshot of the table",
          action: function(e, dt, node, config) {
              AlertService.showInProgressMessage(PrintAndCopyService.getSnapMessage(),'Snap in progress....');
              setTimeout(function() {
                GoogleService.logClickEvent(vm.reportPageTypeName, "Snap", 0, vm);
                const vm2nd = vm;
                PrintAndCopyService.snapChart(dataContainerId, vm, false, true, false).then(function() {
                  AlertService.closeAlert(0);
                });
              }, 1000);
          }
        },
        { extend: "excelHtml5", text: "<img class='dt-image-button' src='/img/file-excel.svg'>", className: "btn margin-btn", titleAttr: "Download excel" ,
          filename: filename,
          bom: true,
          title: null,
          action: function (e, dt, button, config) {
              cellDecimals = {};
              cellTypes = {};
              columnMaxLength = {};
              customRowIdx = 0;
              dt.rows().invalidate();   // Force DataTables to refresh internal cache
              dt.buttons.exportData();  // Clear Buttons internal cache
              // Call original excel action
              $.fn.dataTable.ext.buttons.excelHtml5.action.call(
                  this, e, dt, button, config
              );
          },
          exportOptions: {
            columns: ':visible',
            format: {
              body: function (data, row, column, node) {
                if (column === 1) {
                  customRowIdx++;
                }

                let exportColIdx = node.cellIndex;
                let rowKey = customRowIdx + "_" + exportColIdx;
                
                if (data == null) return '';
                  
                // Normalize string
                if (typeof data === "string") {
                  data = data.replace(/<br\s*\/?>/gi, "\n");
                  data = data.replace(/<[^>]+>/g, "");

                  // Decode HTML entities
                  const txt = document.createElement("textarea");
                  txt.innerHTML = data;
                  data = txt.value.trim();
                }
                
                let tempData = data;
                // Track max content length for AUTO width
                let textValue = tempData != null ? tempData.toString() : '';
                
                if (!columnMaxLength[exportColIdx] || textValue.length > columnMaxLength[exportColIdx]) {
                    columnMaxLength[exportColIdx] = textValue.length;
                }

                // Arrow values → force TEXT
                if (typeof data === 'string' && /[▲▼]/.test(data)) {
                  cellTypes[rowKey] = 'txt';
                  return "\u200B" + data;
                }

                // Percentage
                if (typeof data === 'string') {
                  const trimmed = data.trim();
                  const percentMatch = trimmed.match(/^\s*([+-]?\d+(\.\d+)?)\s*%\s*$/);

                  if (percentMatch) {
                    let valueStr = percentMatch[1];
                    let decimals = 0;
                    if (valueStr.includes('.')) {
                        decimals = valueStr.split('.')[1].length;
                    }
                    cellTypes[rowKey] = 'percent';
                    cellDecimals[rowKey] = decimals;

                    return Number(valueStr) / 100;
                  }
                }

                // Numeric
                if (data !== '' && !isNaN(data)) {
                  let valueStr = data.toString();
                  let decimals = 0;
                  if (valueStr.includes('.')) {
                    decimals = valueStr.split('.')[1].length;
                  }
                  cellTypes[rowKey] = 'num';
                  cellDecimals[rowKey] = decimals;

                  return Number(data);
                }
                
                // Normal text → TEXT (no zero-width space)
                if (typeof data === 'string') {
                  cellTypes[rowKey] = 'txt';
                  return data;
                }

                // Blank
                return '';
              }
            }
          },
          customize: function (xlsx) {
            let sheet = xlsx.xl.worksheets["sheet1.xml"];
            let styles = xlsx.xl["styles.xml"];

            const baseStyleId = $("cellXfs xf", styles).length;
            let numFmts = $("numFmts", styles);

            const customFormats = [
                { id: 164, format: "0%" },       // 0 decimal
                { id: 165, format: "0.0" },    // 1 decimal
                { id: 166, format: "0.000" },   // 3 decimals
                { id: 167, format: "0.0%" },     // percent 1 decimal
                { id: 168, format: "0.00%" },    // percent 2 decimals
                { id: 169, format: "0.000%" }    // percent 3 decimals
            ];

            customFormats.forEach(f => {
                if (numFmts.length === 0) {
                    styles.childNodes[0].childNodes[0].innerHTML =
                        `<numFmts count="1"><numFmt numFmtId="${f.id}" formatCode="${f.format}"/></numFmts>` +
                        styles.childNodes[0].childNodes[0].innerHTML;
                    numFmts = $("numFmts", styles);
                } else {
                    numFmts.append(`<numFmt numFmtId="${f.id}" formatCode="${f.format}"/>`);
                    numFmts.attr("count", parseInt(numFmts.attr("count")) + 1);
                }
            });

            // Normal wrap style
            $("cellXfs", styles).append(
              '<xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0" applyAlignment="1">' +
                '<alignment vertical="top"/>' +
              '</xf>'
            );
            
            // Numeric style with 1 decimal (0.0)
            $("cellXfs", styles).append(
              '<xf numFmtId="165" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1" applyAlignment="1">' +
                '<alignment vertical="top"/>' +
              '</xf>'
            );
            // Numeric style with 2 decimals (0.00)
            $("cellXfs", styles).append(
              '<xf numFmtId="4" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1" applyAlignment="1">' +
                '<alignment vertical="top"/>' +
              '</xf>'
            );
            // Numeric style with 3 decimals (0.000)
            $("cellXfs", styles).append(
              '<xf numFmtId="166" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1" applyAlignment="1">' +
                '<alignment vertical="top"/>' +
              '</xf>'
            );

            // Percent 0 decimal (0%)
            $("cellXfs", styles).append(
              '<xf numFmtId="164" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1" applyAlignment="1">' +
                '<alignment vertical="top"/>' +
              '</xf>'
            );
            // Percentage style with 1 decimal (0.0%)
            $("cellXfs", styles).append(
                '<xf numFmtId="167" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1">' +
                  '<alignment vertical="top"/>' +
                '</xf>'
            );
            // Percentage style with 2 decimals (0.00%)
            $("cellXfs", styles).append(
                '<xf numFmtId="168" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1">' +
                  '<alignment vertical="top"/>' +
                '</xf>'
            );
            // Percentage style with 3 decimals (0.000%)
            $("cellXfs", styles).append(
                '<xf numFmtId="169" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1">' +
                  '<alignment vertical="top"/>' +
                '</xf>'
            );

            const wrapStyleId     = baseStyleId;
            const numeric1StyleId = baseStyleId + 1;
            const numeric2StyleId = baseStyleId + 2;
            const numeric3StyleId = baseStyleId + 3;

            const percent0StyleId = baseStyleId + 4;
            const percent1StyleId = baseStyleId + 5;
            const percent2StyleId = baseStyleId + 6;
            const percent3StyleId = baseStyleId + 7;

            let dataRowTracker = 0;
            
            $("row", sheet).each(function (rowIndex) {
              // Skip header row (rowIndex = 0)
              if (rowIndex === 0) return;

              let currentRow = $(this);
              // let logicalDataRowIndex = cellTypes[dataRowTracker]; // Get the original row ID (e.g., 12 or 14)
              dataRowTracker++;

              // // The data index is simply the row loop index minus the header
              // let excelRowKey = rowIndex - 1;
              
              $(this).children("c").each(function () {
                let cell = $(this);
                
                // ---- 1. Get real column index from cell reference ----
                let ref = cell.attr("r"); // e.g. "D3"
                if (!ref) return;

                let colLetters = ref.replace(/[0-9]/g, '');
                let excelIdx = 0;
                for (let i = 0; i < colLetters.length; i++) {
                    excelIdx = excelIdx * 26 + (colLetters.charCodeAt(i) - 64);
                }
                excelIdx -= 1; // zero-based

                // ---- 2. Get value safely ----
                let cellText = '';
                let cellType = cell.attr("t");

                if (cellType === "inlineStr") {
                    // Inline text
                    cellText = cell.find("t").text();
                }
                else if (cellType === "s") {
                    // Shared string
                    let sharedStrings = xlsx.xl['sharedStrings.xml'];
                    let idx = parseInt(cell.find("v").text(), 10);
                    cellText = $('si', sharedStrings).eq(idx).text();
                }
                else {
                    // Numeric or normal
                    let vNode = cell.find("v");
                    if (vNode.length === 0) return; // blank cell
                    cellText = vNode.text();
                }

                // ---- 3. Skip blanks ----
                if (!cellText || cellText.trim() === '') {
                    return;
                }

                // ---- 4. Keep "--" as text ----
                if (cellText.trim() === "--") {
                    cell.attr("s", wrapStyleId);
                    return;
                }

                // USE THE EXPORT INDEX FOR THE KEY
                let key = dataRowTracker + "_" + excelIdx;

                if (cellTypes[key] === undefined) {
                  return;
                }

                // ---- 5. Apply Numeric styles ----
                if (cellTypes[key] === 'num') {
                  let numberdec = cellDecimals[key] || 0;

                  if (numberdec === 0) {
                      // integer → default
                  }
                  else if (numberdec === 1) {
                      cell.attr("s", numeric1StyleId);
                  }
                  else if (numberdec === 3) {
                      cell.attr("s", numeric3StyleId);
                  }
                  else {
                      cell.attr("s", numeric2StyleId);
                  }
                  return;
                }

                // ---- 6. Apply Percentage styles ----
                if (cellTypes[key] === 'percent') {
                  let percentdec = cellDecimals[key] || 0;

                  if (percentdec === 0) {
                      cell.attr("s", percent0StyleId);
                  }
                  else if (percentdec === 1) {
                      cell.attr("s", percent1StyleId);
                  }
                  else if (percentdec === 3) {
                      cell.attr("s", percent3StyleId);
                  }
                  else {
                      cell.attr("s", percent2StyleId);
                  }
                  return;
                }

                // ---- 7. Default text wrap ----
                cell.attr("s", wrapStyleId);
                
              });
            });

            // ----- SET WIDTH FOR ALL COLUMNS (BEFORE HEADER STYLING) -----
            $('cols', sheet).remove();

            let totalCols = $('row:first c', sheet).length;

            // Auto width factor (Excel approx)
            const MAX_WIDTH = 40;
            const MIN_WIDTH = 10;
            const CHAR_WIDTH_FACTOR = 1.2;
            // columnMaxLength does not contains entries for non-visible columns
            // to keep consistent with excel columns...
            let visibleColKeys = Object.keys(columnMaxLength)
              .map(k => parseInt(k, 10))
              .sort((a, b) => a - b);   // e.g. [1,2,3,4,5,6,7,8]

            let colsXml = '<cols>';

            for (let i = 1; i <= totalCols; i++) {
              let key = visibleColKeys[i-1];      // map exported col # → real key
              let maxLen = (key !== undefined ? columnMaxLength[key] : 10);
              // Calculate auto width
              let width = Math.floor(maxLen * CHAR_WIDTH_FACTOR);

              // Apply limits
              if (width < MIN_WIDTH) width = MIN_WIDTH;
              if (width > MAX_WIDTH) width = MAX_WIDTH;

              colsXml += `<col min="${i}" max="${i}" width="${width}" customWidth="1"/>`;
            }

            colsXml += '</cols>';

            // IMPORTANT: Insert BEFORE sheetData (Excel requires this order)
            $('sheetData', sheet).before(colsXml);

            // Header bold
            $("row", sheet).first().find("c").attr("s", "2");
          }
        },
        { extend: "copy", text: "<img class='dt-image-button-lg' src='/img/clipboard-list-check.svg'>", className: "btn", titleAttr: "Clip and paste data" },
      ]
    };
    if (displayProfileStrengthLegend == true){
      let profileStrengthButton = {
          text: "<div class='label'>Relative Strength</div><div class='profiles-strength'></div>",
          className: "profiles-strength-container",
          titleAttr: "Legend for Relative Strength",
          action: function(e, dt, node, config) {}
      };
      buttonConfiguration.buttons.push(profileStrengthButton);
    }
    return buttonConfiguration;
  }
  getMoatLongName(shortName) {
    let searchableMoat = this.moatMapping.find(x => x.shortName == shortName);
    if (typeof searchableMoat != "undefined") {
      return searchableMoat.longName;
    } else {
      return "";
    }
  }
  setCompanyColorList(list) {
    this.companyColorList = list;
  }
  getCompanyColorList(companyName) {
    let searchableCompany = this.companyColorList.find(x => x.companyName == companyName);
    if (typeof searchableCompany != "undefined") {
      return searchableCompany.color;
    } else {
      return "";
    }
  }
  getMoatNameTableAttribute(position) {
    return {
      targets: position,
      className: "dt-left",
      width: 190,
      render: function(data, type, row, meta) {
        var parameters = meta.settings.oInit.columnDefs[meta.col].parameters;
        let fieldNumber = meta.row + 1;
        if (type === "display") {
          let originalData = data;
          if (originalData != "--") {
            fieldNumber = NeedsService.getMoatNumber(data);
            if (fieldNumber == 0) {
              fieldNumber = meta.row + 1;
            }
          }
          let needName = "Moat " + fieldNumber;
          data = '<span class="popUp" data-modal-name="' + needName + '"><i class="fa-duotone fa-circle-info" style="color:#2f5eb3; padding-right:5px;"></i></span>' + data;
        }
        return data;
      }
    };
  }
  getMainMoatNameTableAttribute(position) {
    return {
      targets: position,
      className: "dt-left",
      width: 90,
      render: function(data, type, row, meta) {
        return data;
      }
    };
  }
  getFunctionalNeedNameTableAttribute(position) {
    return {
      targets: position,
      className: "dt-left",
      width: 130,
      render: function(data, type, row, meta) {
        if (data == null) {
          return null;
        }
        let dataLengthMax = 40;
        var parameters = meta.settings.oInit.columnDefs[meta.col].parameters;
        let originalData = data;
        data = data.length > dataLengthMax ? data.substr(0, dataLengthMax) + "…" : data;
        let displayData = data;
        let includeToolTip = data.length > dataLengthMax;
        if (type === "display" && originalData != "Functional Average" && originalData != "Emotional Average" && originalData != "Overall Average")  {
          let isEmotional = NeedsService.isEmotionalNeedByDimensionName(data);
          let needType = isEmotional ? "emotional" : "functional";
          let fieldNumber = NeedsService.getNeedNumber(data, needType);
          if (fieldNumber == 0) {
            fieldNumber = meta.row + 1;
          }
          let needName = "Functional Need " + fieldNumber;
          data =
            '<div class="my_ellipse"><span class="popUpForRoadMapInitiatives"  data-modal-name="' + needName + '" data-need-number="' + fieldNumber + '" data-need-type="' + needType + '"><img src="/img/icons/wratings-mini-logo.png" class="icon-table-view"/></span>';
          data += ' <span class="popUpForExplorer"  data-modal-name="' + needName + '" data-need-number="' + fieldNumber + '" data-need-type="' + needType + '"><img src="/img/magnifying-glass-dollar.svg" class="icon-table-view"/></span>';
          if (includeToolTip) {
            data += '<span data-toggle="tooltip" title="' + originalData + '">' + displayData + "</span>";
          } else {
            data += displayData;
          }
          data += "</div>";
        }
        return data;
      }
    };
  }
  getEmotionalNeedNameTableAttribute(position) {
    return {
      targets: position,
      className: "dt-left",
      width: 170,
      render: function(data, type, row, meta) {
        if (data == null) {
          return null;
        }
        let dataLengthMax = 40;
        let originalData = data;
        if (type === "display" && originalData != "Emotional Average" && originalData != "Overall Average" ) {
          let isEmotional = NeedsService.isEmotionalNeedByDimensionName(data);
          let needType = isEmotional ? "emotional" : "functional";
          data = data.length > dataLengthMax ? data.substr(0, dataLengthMax) + "…" : data;
          let displayData = data;
          let includeToolTip = data.length > dataLengthMax;
          let fieldNumber = NeedsService.getNeedNumber(data, "emotional");
          if (fieldNumber == 0) {
            fieldNumber = meta.row + 1;
          } else if (fieldNumber > 5) {
            return data;
          }
          let needName = "Emotional Need " + fieldNumber;
          data =
            '<div class="my_ellipse"><span class="popUpForRoadMapInitiatives"  data-modal-name="' + needName + '" data-need-number="' + fieldNumber + '" data-need-type="' + needType + '"><img src="/img/icons/wratings-mini-logo.png" class="icon-table-view"/></span>';
                      data += ' <span class="popUpForExplorer"  data-modal-name="' + needName + '" data-need-number="' + fieldNumber + '" data-need-type="' + needType + '"><img src="/img/magnifying-glass-dollar.svg" class="icon-table-view"/></span>';
          if (includeToolTip) {
            data += '<span data-toggle="tooltip" title="' + originalData + '">' + displayData + "</span>";
          } else {
            data += displayData;
          }
          data += "</div>";
        }
        return data;
      }
    };
  }
  getBaseColumn(position, className, width){
    return {
      targets: position,
      width: width,
      className: className,
      render(v) {
        return v;
      }
    };
  }  
  getNumericTableAttributeDefaultBlank(position, className, width, precision = 2) {
    return {
      targets: position,
      width: width,
      className: className,
      type: 'non-empty-string',
      render(v) {
        if (v != null && !isNaN(v)) {
          return Number(v).toFixed(precision);
        } else {
          return " ";
        }
      }
    };
  }  
  getNumericTableAttribute(position, className, width, precision = 2) {
    return {
      targets: position,
      width: width,
      className: className,
      type: 'non-empty-string',
      render(v) {
        if (v == null){
          return " ";
        }
        if (v != null && !isNaN(v)) {
          return Number(v).toFixed(precision);
        } else {
          return EMPTY_CELL;
        }
      }
    };
  }  
  getNumericTableAttributeRanks(position, className, width, defaultValue = EMPTY_CELL) {
    return {
      targets: position,
      width: width,
      className: className,
      type: 'non-empty-string',
      render(v) {
        if (v != null && !isNaN(v) && v != "") {
          return Number(v).toFixed(3);
        } else {
          return defaultValue;
        }
      }
    };
  }
  getDollarTableAttribute(position, className, width, precision) {
    return {
      targets: position,
      width: width,
      className: className,
      type: 'non-empty-string',
      render(v) {
        if (v != null && !isNaN(v)) {
          return "$ " + Number(v).toFixed(precision);
        } else {
          return EMPTY_CELL;
        }
      }
    };
  }
  getSalesWizardTableColumnAttributes() {
    return [
      this.getOrderSequence(),
      { targets: [0], visible: false },
      this.getNPSTableAttribute([1], "dt-left", 125),
      this.getPercentTableAttribute("_all", "dt-right", 50, 1),
    ];
  }
  getNPSTableAttribute(position, className, width) {
    return {
      targets: position,
      width: width,
      className: className,
      render(v) {
        if (v != null && !isNaN(v) && v == ".0") {
          return Number(v).toFixed(1);
        } else {
          return v;
        }
      }
    }
  }
  getRankTableAttribute(position, className, width) {
    return {
      targets: position,
      width: width,
      className: className,
      type: 'num', // numeric column
      render(v, type) {

        // Excel export, sorting, filtering → keep it numeric
        if (type === 'sort' || type === 'type' || type === 'export') {
          return (v != null && !isNaN(v) && v !== 0) ? Number(v) : null;
        }

        // UI display → show blank if no value
        if (v != null && !isNaN(v) && v !== 0) {
          return v;
        }

        return ''; // BLANK (not null, not 0)
      }
    };
  }
  getRankPercentTableAttribute(position, className, width, precision) {
    return {
      targets: position,
      width: width,
      className: className,
      type: 'non-empty-string',
      render(v) {
        if (v != null && !isNaN(v) && v != 0) {
          return Number(v).toFixed(precision) + "%";
        } else {
          return " ";
        }
      }
    };
  }
  getMoneyTableAttribute(position, className, width, precision) {
    return {
      targets: position,
      width: width,
      className: className,
      type: 'non-empty-string',
      render(v) {
        if (v != null && !isNaN(v)) {
          return "$"+Number(v).toFixed(precision);
        } else {
          return EMPTY_CELL
        }
      }
    };
  }
  getPercentTableAttributeDefaultBlank(position, className, width, precision) {
    return {
      targets: position,
      width: width,
      className: className,
      type: 'non-empty-string',
      render(v) {
        if (v != null && !isNaN(v)) {
          return Number(v).toFixed(precision) + "%";
        } else {
          return " ";
        }
      }
    };
  }
  getPercentTableAttribute(position, className, width, precision) {
    return {
      targets: position,
      width: width,
      className: className,
      type: 'non-empty-string',
      render(v) {
        if (v == null){
          return " ";
        } 
        if (v != null && !isNaN(v)) {
          return Number(v).toFixed(precision) + "%";
        } else {
          return EMPTY_CELL
        }
      }
    };
  }
  getPercentTableAttributeRanks(position, className, width, precision, defaultValue = EMPTY_CELL) {
    return {
      targets: position,
      width: width,
      className: className,
      type: 'non-empty-string',
      render(v) {
        if (v != null && !isNaN(v) && v != "") {
          return Number(v).toFixed(precision) + "%";
        } else {
          return defaultValue
        }
      }
    };
  }
  getRelativeStrengthTableAttribute(position, className, width,precision,isPositiveCorrelation = true) {
    if (isPositiveCorrelation == true){
      return {
        targets: position,
        className: className,
        width: width,
        createdCell: function(td, cellData, rowData, row, col) {
          // see if it is a string, if so convert it to a number
          if (typeof cellData === "string") {
            cellData = parseFloat(cellData);
          }
          if (cellData >= 0.8 && cellData <= 1.0) {
            $(td).addClass("very-strong-correlation");
          } else if (cellData >= 0.5 && cellData < 0.8) {
            $(td).addClass("strong-correlation");
          } else if (cellData >= 0.3 && cellData < 0.5) {
            $(td).addClass("mild-correlation");
          }
        },
        render(v) {
          if (v != null && !isNaN(v) && v != 0) {
            return Number(v).toFixed(2);
          }
          return EMPTY_CELL;
        }
      };
    }
    
    return {
      targets: position,
      className: className,
      width: width,
      createdCell: function(td, cellData, rowData, row, col) {
        if (typeof cellData === "string") {
          cellData = parseFloat(cellData);
        }
        if (cellData <= -0.8 && cellData >= -1.0) {
          $(td).addClass("very-strong-correlation");
        } else if (cellData <= -0.5 && cellData > -0.8) {
          $(td).addClass("strong-correlation");
        } else if (cellData <= -0.3 && cellData > -0.5) {
          $(td).addClass("mild-correlation");
        }          
      },
      render(v) {
        if (v != null && !isNaN(v) && v != 0) {
          return Number(v).toFixed(2);
        }
        return EMPTY_CELL;
      }
    };
  }
  getMetricTableAttribute(position, className, width) {
    return {
      targets: position,
      className: className,
      width: width,
      render: function(data, type, row, meta) {
        return data;
      }
    };
  }
  getBaseTableAttribute(position, className, width) {
    return {
      targets: position,
      className: className,
      width: width,
      render: function(data, type, row, meta) {
        return data;
      }
    };
  }
  getOrderSequence() {
    return { orderSequence: ["desc", "asc"], targets: ["_all"] };
  }
  setRowColor(row, rowColor) {
    row.css("color", rowColor);
  }
  setHeaderColor(column) {
    let columnText = column.text();
    let columnColor = this.getCompanyColorList(columnText);
    if (columnColor != "") {
      column.css("background-color", columnColor);
      column.css("color", "#fff");
    }
  }
  getManageInvitationsTableColumnAttributes() {
    return [
      {
        title: "Unique Code Id",
        data: "surveyUniqueCodeId",
        createdCell: function(td, cellData, rowData, row, col) {
          $(td).addClass("text-center");
        },
        className: "",
        name: "id",
        width: "3rem"
      },
      { title: "Survey Name", data: "surveyName", name: "surveyName", width: "5rem" },
      { title: "Email Address", data: "emailAddress", name: "emailAddress", width: "7rem" },
      { title: "Unique Code", data: "uniqueCode", name: "uniqueCode", width: "5rem" },
      { title: "Url", data: "url", name: "url", width: "15rem" },
      { title: "Segment Data", data: "defaultValues", name: "defaultValues", width: "15rem" },
      {
        title: "Status",
        data: "status",
        className: "",
        name: "status",
        width: "3rem",
        render: function(data, type, row) {
          var statusMap = { C: { label: "Complete", style: "warning" }, R: { label: "Ready", style: "success" }, I: { label: "Inactive", style: "secondary" } };
          if (type === "display") {
            return "<p class='m-0 p-0' style='width: 4rem;'><span class='badge badge-" + statusMap[data].style + "'>" + statusMap[data].label + "</span></p>";
          } else {
            return data;
          }
        }
      },
      {
        title: "Date Created",
        data: "dateCreated",
        type: "date",
        name: "dateCreated",
        class: "text-left",
        width: "4rem",
        render: function(data, type, row) {
          if (data != null) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY");
          } else {
            return "";
          }
        }
      },
      {
        title: "Date Completed",
        data: "dateCompleted",
        type: "date",
        name: "dateCompleted",
        class: "text-left",
        width: "4rem",
        render: function(data, type, row) {
          if (data != null) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          } else {
            return "";
          }          
        }
      }
    ];
  }
  getNpsTableColumnAttributes() {
    return [
      this.getBaseTableAttribute([0], "dt-left", 130),
      this.getNPSTableAttribute([1], "dt-right", 50),
      {
        targets: "_all",
        width: 50,
        className: "dt-right",
        render(v) {
          if (v != null && !isNaN(v) && v == ".0") {
            return Number(v).toFixed(1);
          } else {
            return v;
          }
        }
      }
    ];
  }
  getTableColumnAttributes(source) {
    if (source == "Match By Value") {
      return {
        columnDefsFunctional: [
          this.getOrderSequence(),
          { targets: [0], visible: false },
          {
            targets: [1],
            className: "dt-left",
            width: 50,
            type: 'non-empty-string',
            render(v) {
              if (v == null) {
                return " ";
              } else if (v != null && !isNaN(v)) {
                if (v == 0) {
                  return EMPTY_CELL;
                }
                v = v * 100;
                return Number(v).toFixed(1) + "%";
              } else {
                return EMPTY_CELL;
              }
            }
          },
          {
            targets: [2],
            width: 150,
            className: "dt-left",
            render: function(data, type, row, meta) {
              return data;
            }
          },
          {
            targets: [3],
            className: "dt-left data-table-border-right",
            width: 190,
            render: function(data, type, row, meta) {
              if (data == null) {
                return null;
              }
              var parameters = meta.settings.oInit.columnDefs[meta.col].parameters;
              let originalData = data;
              data = data.length > 40 ? data.substr(0, 40) + "…" : data;
              let displayData = data;
              let includeToolTip = data.length > 40;

              if (type === "display"  && originalData != "Emotional Average" && originalData != "Functional Average" && originalData != "Overall Average") {
                let isEmotional = NeedsService.isEmotionalNeedByDimensionName(data);
                let needType = isEmotional ? "emotional" : "functional";
                let fieldNumber = NeedsService.getNeedNumber(data, needType);
                if (fieldNumber == 0) {
                  fieldNumber = meta.row + 1;
                }
                let needName = "Functional Need " + fieldNumber;
                data =
                  '<div class="my_ellipse"><span class="popUpForRoadMapInitiatives"  data-modal-name="' +
                  needName +
                  '" data-need-number="' + fieldNumber + '" data-need-type="' + needType + '"><img src="/img/icons/wratings-mini-logo.png" class="icon-table-view"/></span>';
                data += ' <span class="popUpForExplorer"  data-modal-name="' + needName + '" data-need-number="' + fieldNumber + '" data-need-type="' + needType + '"><img src="/img/magnifying-glass-dollar.svg" class="icon-table-view"/></span>';
                if (includeToolTip) {
                  data += '<span data-toggle="tooltip" title="' + originalData + '">' + displayData + "</span>";
                } else {
                  data += displayData;
                }
                data += "</div>";
              }
              return data;
            }
          },
          this.getNumericTableAttribute([4], "dt-right", 50),
          this.getNumericTableAttribute([5], "dt-right", 50),
          this.getNumericTableAttribute([6], "dt-right", 50),
          this.getNumericTableAttribute([-1], "dt-right", 50, 1),
          this.getNumericTableAttribute(["_all"], "dt-right", 50)
        ]
      };
    } else if (source == "Profile By Sales Wizard") {
      return this.getSalesWizardTableColumnAttributes();
    } else if (source == "Profile By Winners") {
      return WinnersService.getTableColumnAttributes();
    } else if (source == "Profile By Moneyball Stick") {
      return {
        columnDefs: [
          this.getOrderSequence(),
          this.getMainMoatNameTableAttribute([0]),
          this.getNumericTableAttribute([1], "dt-right", 50, 2),
          this.getNumericTableAttribute([2], "dt-right", 50, 2),
          this.getNumericTableAttribute([3], "dt-right", 50, 2),
          this.getNumericTableAttribute([4], "dt-right", 50, 2),
          this.getPercentTableAttribute([5], "dt-right", 50, 1),
          this.getNumericTableAttribute([6], "dt-right", 50, 1),
          this.getNumericTableAttribute([7], "dt-right", 50, 1),
          this.getPercentTableAttribute([8], "dt-right", 50, 1),
          this.getPercentTableAttribute([9], "dt-right", 50, 1),
          this.getPercentTableAttribute([10], "dt-right", 50, 1),
          this.getNumericTableAttribute(["_all"], "dt-right", 50, 1)
        ]
      };
    } else if (source == "Profile By Value Roadmap") {
      return {
        columnDefs: [
          this.getOrderSequence(),
          {
            targets: [0],
            className: "dt-left",
            width: 120,
            render: function(data, type, row, meta) {
              return data;
            }
          },
          {
            targets: [1],
            className: "dt-left",
            width: 190,
            render: function(data, type, row, meta) {
              if (data == null){
                return "";
              }
              var parameters = meta.settings.oInit.columnDefs[meta.col].parameters;
              let originalData = data;
              data = data.length > 40 ? data.substr(0, 40) + "…" : data;
              let displayData = data;
              let includeToolTip = data.length > 40;

              if (type === "display"  && originalData != "Functional Average" && originalData != "Emotional Average"  && originalData != "Overall Average"
                && originalData != "Focus Area Average" && originalData != "Other Area Average"
              ) {
                let isEmotional = NeedsService.isEmotionalNeedByDimensionName(data);
                let needType = isEmotional ? "emotional" : "functional";
                let fieldNumber = NeedsService.getNeedNumber(data, needType);
                if (fieldNumber == 0) {
                  fieldNumber = meta.row + 1;
                }
                let needName = isEmotional ? "Emotional Need " : "Functional Need ";
                needName += fieldNumber;
                data = '<span class="popUpForRoadMapInitiatives"  data-modal-name="' + needName + '" data-need-number="' + fieldNumber + '" data-need-type="' + needType + '"><img src="/img/icons/wratings-mini-logo.png" class="icon-table-view"/></span>';
                data += ' <span class="popUpForExplorer"  data-modal-name="' + needName + '" data-need-number="' + fieldNumber + '" data-need-type="' + needType + '"><img src="/img/magnifying-glass-dollar.svg" class="icon-table-view"/></span>';
                if (includeToolTip) {
                  data += '<span data-toggle="tooltip" title="' + originalData + '">' + displayData + "</span>";
                } else {
                  data += displayData;
                }
              }
              return data;
            }
          },
          this.getNumericTableAttributeDefaultBlank([2], "dt-right", 50),
          this.getNumericTableAttributeDefaultBlank([3], "dt-right", 50),
          this.getNumericTableAttributeDefaultBlank([4], "dt-right ", 50),
          this.getPercentTableAttributeDefaultBlank([-2], "dt-right", 50, 2),
          this.getNumericTableAttributeDefaultBlank(["_all"], "dt-right", 50, 1)
        ]
      };
    }  else if (source == "Match By Moat") {
      return {
        columnDefs: [
          this.getOrderSequence(),
          {
            targets: [0],
            className: "dt-left",
            width: 120,
            render: function(data, type, row, meta) {
              var parameters = meta.settings.oInit.columnDefs[meta.col].parameters;
              return data;
            }
          },
          {
            targets: [1],
            className: "dt-left",
            width: 190,
            render: function(data, type, row, meta) {
              if (data == null) {
                return null;
              }
              var parameters = meta.settings.oInit.columnDefs[meta.col].parameters;
              let originalData = data;
              data = data.length > 40 ? data.substr(0, 40) + "…" : data;
              let displayData = data;
              let includeToolTip = data.length > 40;

              if (type === "display"  && originalData != "Functional Average" && originalData != "Emotional Average"  && originalData != "Overall Average") {
                let isEmotional = NeedsService.isEmotionalNeedByDimensionName(data);
                let needType = isEmotional ? "emotional" : "functional";
                let fieldNumber = NeedsService.getNeedNumber(data, needType);
                if (fieldNumber == 0) {
                  fieldNumber = meta.row + 1;
                }
                let needName = isEmotional ? "Emotional Need " : "Functional Need ";
                needName += fieldNumber;
                data = '<span class="popUpForRoadMapInitiatives"  data-modal-name="' + needName + '" data-need-number="' + fieldNumber + '" data-need-type="' + needType + '"><img src="/img/icons/wratings-mini-logo.png" class="icon-table-view"/></span>';
                data += ' <span class="popUpForExplorer"  data-modal-name="' + needName + '" data-need-number="' + fieldNumber + '" data-need-type="' + needType + '"><img src="/img/magnifying-glass-dollar.svg" class="icon-table-view"/></span>';
                if (includeToolTip) {
                  data += '<span data-toggle="tooltip" title="' + originalData + '">' + displayData + "</span>";
                } else {
                  data += displayData;
                }
              }
              return data;
            }
          },
          this.getNumericTableAttribute([2], "dt-right ", 50),
          this.getNumericTableAttribute([3], "dt-right ", 50),
          this.getNumericTableAttribute([4], "dt-right ", 50),
          this.getNumericTableAttribute(["_all"], "dt-right", 50)
        ]
      };
    } else if (source == "Match By Winners") {
      return {
        columnDefs: [
          this.getOrderSequence(),
          {
            targets: [0],
            className: "dt-left",
            width: 120,
            render: function(data, type, row, meta) {
              var parameters = meta.settings.oInit.columnDefs[meta.col].parameters;
              if (type === "display") {
                let originalData = data;
                let headerForTableStakes = "Table Stakes - Header";
                let headerForCore = "Core - Header";
                let headerForDiverge = "Diverge - Header";
                let firstInstanceOfTableStakes = true;
                let firstInstanceOfCore = true;
                let firstInstanceOfDiverge = true;
  
                if (originalData != "--" && headerForTableStakes == data && firstInstanceOfTableStakes) {
                  data = "Table Stakes";
                  data = '<span class="popUp" data-modal-name="' + data + '"><i class="fa-duotone fa-circle-info" style="color:#2f5eb3; padding-right:5px;"></i></span>' + data;
                  firstInstanceOfTableStakes = false;
                } else if (originalData != "--" && headerForCore == data && firstInstanceOfCore) {
                  data = "Core";
                  data = '<span class="popUp" data-modal-name="' + data + '"><i class="fa-duotone fa-circle-info" style="color:#2f5eb3; padding-right:5px;"></i></span>' + data;
                  firstInstanceOfCore = false;
                } else if (originalData != "--" && headerForDiverge == data && firstInstanceOfDiverge) {
                  data = "Diverge";
                  data = '<span class="popUp" data-modal-name="' + data + '"><i class="fa-duotone fa-circle-info" style="color:#2f5eb3; padding-right:5px;"></i></span>' + data;
                  firstInstanceOfDiverge = false;
                }
                return data;
              }
              return data;
            }
          },
          {
            targets: [1],
            className: "dt-left",
            width: 190,
            render: function(data, type, row, meta) {
              if (data == null) {
                return null;
              }
              var parameters = meta.settings.oInit.columnDefs[meta.col].parameters;
              let originalData = data;
              data = data.length > 40 ? data.substr(0, 40) + "…" : data;
              let displayData = data;
              let includeToolTip = data.length > 40;

              if (type === "display") {
                let isEmotional = NeedsService.isEmotionalNeedByDimensionName(data);
                let needType = isEmotional ? "emotional" : "functional";
                let fieldNumber = NeedsService.getNeedNumber(data, needType);
                if (fieldNumber == 0) {
                  fieldNumber = meta.row + 1;
                }
                let needName = isEmotional ? "Emotional Need " : "Functional Need ";
                needName += fieldNumber;
                data = '<span class="popUp"  data-modal-name="' + needName + '"><i class="fa-duotone fa-circle-info" style="color:#2f5eb3; padding-right:5px;"></i></span>';
                if (includeToolTip) {
                  data += '<span data-toggle="tooltip" title="' + originalData + '">' + displayData + "</span>";
                } else {
                  data += displayData;
                }
              }
              return data;
            }
          },
          this.getNumericTableAttribute([2], "dt-right ", 50),
          this.getNumericTableAttribute([3], "dt-right ", 50),
          this.getNumericTableAttribute([4], "dt-right ", 50),
          this.getNumericTableAttribute(["_all"], "dt-right", 50)
        ]
      };
    } else if (source == "Profile") {
      return {
        columnDefsFunctional: [
          this.getOrderSequence(),
          { targets: [0], visible: false },
          this.getFunctionalNeedNameTableAttribute([1]),
          this.getNumericTableAttribute([2], "dt-right", 50),
          this.getNumericTableAttribute([3], "dt-right", 50),
          this.getNumericTableAttribute([4], "dt-right", 50),
          this.getNumericTableAttribute([-1], "dt-right", 50, 2),
          this.getPercentTableAttribute([-2], "dt-right", 50, 2),
          this.getNumericTableAttribute(["_all"], "dt-right", 50)
        ],
      };
    } else if (source == "Match") {
      return {
        columnDefsFunctional: [
          this.getOrderSequence(),
          { targets: [0], visible: false },
          this.getFunctionalNeedNameTableAttribute([1]),
          this.getNumericTableAttribute([2], "dt-right", 50),
          this.getNumericTableAttribute([3], "dt-right", 50),
          this.getNumericTableAttribute([4], "dt-right", 50),
          this.getNumericTableAttribute(["_all"], "dt-right", 50)
        ],
      };
    } else if (source == "Explore") {
      return {
        columnDefs: [
          this.getOrderSequence(),
          this.getBaseTableAttribute([0], "dt-left", 70),
          this.getPercentTableAttribute([1], "dt-right chart-light-green", 75, 2),
          this.getNumericTableAttribute([2], "dt-right", 75),
          this.getNumericTableAttribute([3], "dt-right", 75),
          this.getNumericTableAttribute(["_all"], "dt-right", 75)
        ]
      };
    } else if (source == "Ranks") {
      return {
        columnDefs: [
          this.getOrderSequence(),
          this.getMoatNameTableAttribute([0]),
          this.getPercentTableAttribute([1], "dt-right", 50, 1),
          this.getPercentTableAttribute(["_all"], "dt-right", 50, 1)
        ]
      };
    } else if (source == "Moats") {
      return {
        columnDefs: [
          this.getOrderSequence(),
          this.getMainMoatNameTableAttribute([0]),
          this.getMoatNameTableAttribute([1]),
          this.getPercentTableAttribute([2], "dt-right", 50, 1),
          this.getPercentTableAttribute(["_all"], "dt-right", 50, 1)
        ]
      };
    } else if (source == "Moat Trends") {
      return {
        columnDefs: [
          this.getOrderSequence(),
          this.getBaseTableAttribute([0], "", 70),
          this.getPercentTableAttribute([1], "dt-right", 50, 1),
          this.getNumericTableAttribute(["_all"], "dt-right", 50, 2)
        ]
      };
    }
    return {};
  }
  getResponseMessageListTableAttributes() {
    return {
      id: "response-message-list-table",
      columns: [
        {
          title: "Id",
          data: "responseMessageLogId",
          createdCell: function(td, cellData, rowData, row, col) {
            $(td).addClass("text-center");
          },
          className: "",
          name: "id",
          width: "4rem"
        },
        { title: "Title", data: "title", name: "title", width: "7rem" },
        { title: "Message", data: "message", name: "message", width: "10rem" },
        {
          title: "Completed",
          data: "completed",
          name: "completed",
          width: "6rem",
          createdCell: function(td, cellData, rowData, row, col) {
            $(td).addClass("text-center");
          }
        },
        {
          title: "Status",
          data: "statusCode",
          name: "statusCode",
          width: "5rem",
          createdCell: function(td, cellData, rowData, row, col) {
            if (cellData != "200") {
              $(td).css("background-color", "red");
              $(td).css("color", "white");
            } else if (cellData == "200") {
              $(td).css("background-color", "green");
              $(td).css("color", "white");
            }
            $(td).addClass("text-center");
          }
        },
        {
          title: "Duration (ms)",
          data: "duration",
          name: "duration",
          width: "7rem",
          createdCell: function(td, cellData, rowData, row, col) {
            $(td).addClass("text-center");
          }
        },
        { title: "Request Path", data: "requestPath", name: "requestPath", width: "12rem" },
        { title: "Request Parameters", data: "requestParameters", name: "requestParameters", width: "18rem" },
        { 
          title: "User Id", 
          data: "userId", 
          name: "userId", 
          width: "5rem",
          createdCell: function(td, cellData, rowData, row, col) {
            $(td).addClass("text-left");
          }
         },
        {
          title: "Date Created",
          data: "dateCreated",
          type: "date",
          name: "dateCreated",
          width: "7rem",
          render: function(data, type, row) {
           return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          },
          createdCell: function(td, cellData, rowData, row, col) {
            $(td).addClass("text-left");
          }
        },
        {
          title: "Date Completed",
          data: "dateCompleted",
          type: "date",
          name: "dateCompleted",
          width: "7rem",
          render: function(data, type, row) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          },
          createdCell: function(td, cellData, rowData, row, col) {
            $(td).addClass("text-left");
          }
        }
      ]
    };
  }
  getApplicationErrorListTableAttributes() {
    return {
      id: "application-error-list-table",
      columns: [
        {
          title: "Id",
          data: "applicationErrorId",
          createdCell: function(td, cellData, rowData, row, col) {
            $(td).addClass("text-center");
          },
          className: "",
          name: "id",
          width: "1rem"
        },
        { title: "Section", data: "applicationErrorType", name: "applicationErrorType", width: "3rem" },
        { title: "Location", data: "location", name: "location", width: "8rem" },
        { title: "Message", data: "errorMessage", name: "errorMessage", width: "20rem" },
        { title: "Client Name", data: "clientName", name: "clientName", width: "5rem" },
        {
          title: "Date Created",
          data: "dateCreated",
          type: "date",
          name: "dateCreated",
          width: "5rem",
          render: function(data, type, row) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          }
        }
      ]
    };
  }
  getPerformanceSummaryTableAttributes() {
    return {
      id: "performance-summary-list-table",
      columns: [
        { title: "Environment", data: "environment", name: "environment", width: "3rem" },
        { title: "Function", data: "functionName", name: "functionName", width: "8rem" },
        { title: "Minimum Duration (ms)", data: "minimumDuration", name: "minimumDuration", width: "3rem" },
        { title: "Maximum Duration (ms)", data: "maximumDuration", name: "minimumDuration", width: "3rem" },
        { title: "Average Duration (ms)", data: "average", name: "average", width: "3rem" },
        { title: "Number of Calls", data: "numberOfRecords", name: "numberOfRecords", width: "3rem" },
        {
          title: "Last Run Date",
          data: "lastRunDate",
          type: "date",
          name: "lastRunDate",
          width: "4rem",
          render: function(data, type, row) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          }
        }
      ]
    };
  }
  getCacheStatisticsTableAttributes() {
    return {
      id: "cache-statistics-list-table",
      columns: [
        { title: "Name", data: "name", name: "name", width: "9rem" },
        { title: "Hits", data: "hits", name: "hits", width: "3rem" },
        {
          title: "Hits %",
          data: "hitPercentage",
          name: "hitPercentage",
          width: "3rem",
          render(v) {
            if (v != null && !isNaN(v)) {
              return Number(v).toFixed(2) + "%";
            } else {
              return "--";
            }
          }
        },
        { title: "Misses", data: "misses", name: "misses", width: "4rem" },
        {
          title: "Miss %",
          data: "missPercentage",
          name: "missPercentage",
          width: "4rem",
          render(v) {
            if (v != null && !isNaN(v)) {
              return Number(v).toFixed(2) + "%";
            } else {
              return "--";
            }
          }
        },
        { title: "Gets", data: "gets", name: "gets", width: "3rem" },
        { title: "Puts", data: "puts", name: "puts", width: "3rem" },
        {
          title: "Average Get Time (ms)",
          data: "averageGetTime",
          name: "averageGetTime",
          width: "5rem",
          render(v) {
            if (v != null && !isNaN(v)) {
              return Number(v).toFixed(2);
            } else {
              return "--";
            }
          }
        },
        {
          title: "Average Put Time (ms)",
          data: "averagePutTime",
          name: "averagePutTime",
          width: "5rem",
          render(v) {
            if (v != null && !isNaN(v)) {
              return Number(v).toFixed(2);
            } else {
              return "--";
            }
          }
        },
        {
          title: "Average Remove Time (ms)",
          data: "averageRemoveTime",
          name: "averageRemoveTime",
          width: "5rem",
          render(v) {
            if (v != null && !isNaN(v)) {
              return Number(v).toFixed(2);
            } else {
              return "--";
            }
          }
        },
        {
          title: "",
          data: "name",
          name: "name",
          width: "6rem",
          render: function(data, type, row, meta) {
            if (type === "display") {
              data = '<button type="button" class="btn btn-clear-cache btn-primary ml-2">Clear Cache</button>';
              //data = '<a href="/clear-cache-by-name?name=' + encodeURIComponent(data.name) + '">Clear Cache</a>';
            }
            return data;
          }
        }
      ]
    };
  }
  getJobSummaryTableAttributes() {
    return {
      id: "job-summary-table",
      columns: [
        { title: "Name", data: "name", name: "name", width: "8rem" },
        { title: "Frequency", data: "frequency", name: "frequency", width: "8rem" },
        { title: "Active", data: "active", name: "active", width: "4rem" },
        {
          title: "Last Run Date",
          data: "dateLastRun",
          type: "date",
          name: "dateLastRun",
          width: "4rem",
          render: function(data, type, row) {
            if (data == null) {
              return "--";
            }
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          }
        },
        {
          title: "Next Run Date",
          data: "dateNextRun",
          type: "date",
          name: "dateNextRun",
          width: "4rem",
          render: function(data, type, row) {
            if (data == null) {
              return "--";
            }
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          }
        },
        {
          title: "Created Date",
          data: "dateCreated",
          type: "date",
          name: "dateCreated",
          width: "4rem",
          render: function(data, type, row) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          }
        },
        {
          title: "Updated Date",
          data: "dateModified",
          type: "date",
          name: "dateModified",
          width: "4rem",
          render: function(data, type, row) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          }
        }
      ]
    };
  }
  getJobExecutionLogTableAttributes() {
    return {
      id: "response-message-list-table",
      columns: [
        {
          title: "Id",
          data: "id",
          createdCell: function(td, cellData, rowData, row, col) {
            $(td).addClass("text-center");
          },
          className: "",
          name: "id",
          width: "4rem"
        },
        { title: "Job Name", data: "jobName", name: "jobName", width: "6rem" },
        { title: "Message", data: "message", name: "message", width: "9rem" },
        {
          title: "Completed",
          data: "completed",
          name: "completed",
          width: "5rem",
          createdCell: function(td, cellData, rowData, row, col) {
            $(td).addClass("text-center");
          }
        },
        {
          title: "Status",
          data: "statusCode",
          name: "statusCode",
          width: "4rem",
          createdCell: function(td, cellData, rowData, row, col) {
            if (cellData != "200") {
              $(td).css("background-color", "red");
              $(td).css("color", "white");
            } else if (cellData == "200") {
              $(td).css("background-color", "green");
              $(td).css("color", "white");
            }
            $(td).addClass("text-center");
          }
        },
        {
          title: "Duration (ms)",
          data: "duration",
          name: "duration",
          width: "4rem",
          createdCell: function(td, cellData, rowData, row, col) {
            $(td).addClass("text-center");
          }
        },
        {
          title: "Date Created",
          data: "dateCreated",
          type: "date",
          name: "dateCreated",
          width: "8rem",
          render: function(data, type, row) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          }
        },
        {
          title: "Date Completed",
          data: "dateCompleted",
          type: "date",
          name: "dateCompleted",
          width: "8rem",
          render: function(data, type, row) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          }
        }
      ]
    };
  }
  getCountsByLocationTableAttributes() {
    return  [
        { data: "count", name: "ipAddress", width: "1rem", 
          createdCell: function(td, cellData, rowData, row, col) {
            $(td).addClass("text-center");
          },
        },
        {  data: "city", name: "city", width: "15rem", 
          createdCell: function(td, cellData, rowData, row, col) {
            $(td).addClass("text-center");
          },
        },
        {  data: "regionCode", name: "regionCode", width: "15rem", 
          createdCell: function(td, cellData, rowData, row, col) {
            $(td).addClass("text-center");
          },
       },
      {  data: "displayCountryCode", name: "displayCountryCode", width: "15rem",
        createdCell: function(td, cellData, rowData, row, col) {
          $(td).addClass("text-center");
        },
       },
      ];
  }  
  getImportTypeAttributes() {
    return {
      id: "import-type-table",
      columns: [
        { title: "Import Type", data: "displayName", name: "name", width: "8rem" },
        { title: "Directory", data: "filepath", name: "filepath", width: "8rem" },
        { title: "Current Function Location", data: "description", name: "description", width: "10rem" },
        { title: "Send to Email", data: "sentToEmail", name: "sentToEmail", width: "12rem" },
        { title: "Processed Fles", data: "processedCount", name: "processedCount", width: "8rem" },
        { title: "Error Fles", data: "errorCount", name: "errorCount", width: "8rem" }
      ]
    };
  } 
  getImportLogTableAttributes() {
    return {
      id: "import-table",
      columns: [
        {
          title: "Id",
          data: "id",
          createdCell: function(td, cellData, rowData, row, col) {
            $(td).addClass("text-center");
          },
          className: "",
          name: "id",
          width: "4rem"
        },
        { title: "Import Type Name", data: "importTypeName", name: "importTypeName", width: "8rem" },
        { title: "File Name", data: "filename", name: "filename", width: "9rem" },
        {
          title: "Status",
          data: "status",
          name: "status",
          width: "6rem",
          createdCell: function(td, cellData, rowData, row, col) {
            $(td).addClass("text-center");
          },
          render: function(data, type, row) {
            var statusMap = {
              C: { label: "Complete", style: "success" },
              I: { label: "Incomplete", style: "warning" },
              E: { label: "Error", style: "danger" }
            };
            if (type === "display") {
              return "<p class='m-0 p-0 text-center' '><span class='badge badge-" + statusMap[data].style + "'>" + statusMap[data].label + "</span></p>";
            } else {
              return data;
            }
          }
        },
        { title: "Response Message", data: "responseMessage", name: "responseMessage", width: "10rem" },
        {
          title: "Duration (ms)",
          data: "duration",
          name: "duration",
          width: "6rem",
          createdCell: function(td, cellData, rowData, row, col) {
            $(td).addClass("text-left");
          },
          render: function(data, type, row) {
            let d = row.duration;
            if (d == null) {
              return "0";
            } else {
              return d;
            }
          }
        },
        {
          title: "Start Date",
          data: "startDate",
          type: "date",
          name: "startDate",
          width: "6rem",
          render: function(data, type, row) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          }
        },
        {
          title: "End Date",
          data: "endDate",
          type: "date",
          name: "endDate",
          width: "6rem",
          render: function(data, type, row) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          }
        },
        
        {
          title: "Date Created",
          data: "dateCreated",
          type: "date",
          name: "dateCreated",
          width: "6rem",
          render: function(data, type, row) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          }
        },
        {
          title: "Date Completed",
          data: "dateCompleted",
          type: "date",
          name: "dateCompleted",
          width: "6rem",
          render: function(data, type, row) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          }
        }
      ]
    };
  }
  getUniqueCodesTableColumnAttributes() {
    return [
      {
        bVisible: true,
        data: "id",
        render: function(data, type, full, meta) {
          return '<input type="checkbox" name="id[]" value="' + full.surveyUniqueCodeId + '" >';
        },
        className: "",
        name: "id",
        width: "4rem"
      },
      {
        title: "Unique Code Id",
        data: "surveyUniqueCodeId",
        createdCell: function(td, cellData, rowData, row, col) {
          $(td).addClass("text-center");
        },
        className: "",
        name: "id",
        width: "5rem"
      },
      { title: "Client", data: "clientName", name: "clientName", width: "8rem" },
      { title: "Parent Client", data: "parentClientName", name: "parentClientName", width: "8rem" },
      { title: "Survey Name", data: "surveyName", name: "surveyName", width: "8rem" },
      { title: "Email Address", data: "emailAddress", name: "emailAddress", width: "7rem" },
      { title: "Unique Code", data: "uniqueCode", name: "uniqueCode", width: "8rem" },
      { title: "Url", data: "url", name: "url", width: "15rem" },
      { title: "Segment Data", data: "defaultValues", name: "defaultValues", width: "15rem" },
      {
        title: "Status",
        data: "status",
        className: "",
        name: "status",
        width: "5rem",
        render: function(data, type, row) {
          var statusMap = { C: { label: "Complete", style: "warning" }, R: { label: "Ready", style: "success" }, I: { label: "Inactive", style: "secondary" } };
          if (type === "display") {
            return "<p class='m-0 p-0' style='width: 4rem;'><span class='badge badge-" + statusMap[data].style + "'>" + statusMap[data].label + "</span></p>";
          } else {
            return data;
          }
        }
      },
      {
        title: "Date Created",
        data: "dateCreated",
        type: "date",
        name: "dateCreated",
        class: "text-left",
        width: "7rem",
        render: function(data, type, row) {
          if (data != null) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY");
          } else {
            return "";
          }
        }
      },
      {
        title: "Date Completed",
        data: "dateCompleted",
        type: "date",
        name: "dateCompleted",
        class: "text-left",
        width: "7rem",
        render: function(data, type, row) {
          if (data != null) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY hh:mm:ss A");
          } else {
            return "";
          }          
        }
      }
    ];
  }
  getTopRecommendationResultsTableAttributes() {
    let returnColumns = [
        { data: "rank", name: "rank", width: "20px", className: "dt-center align-top" },
        { data: "valueSource", name: "valueSource", width: "5rem", className: "dt-left align-top" },
        { data: "summaryRecommendation", 
          name: "summaryRecommendation", 
          width: "5rem", 
          className: "dt-left align-top"
        },
        {
          data: "keyDataPointsUsed",
          name: "keyDataPointsUsed",
          width: "8rem",
          className: "dt-left align-top",
          render: function(data) {
            if (data == null) {
              return "";
            }
            return String(data)
                .replace(/\\n/g, "<br>")
                .replace(/\r?\n/g, "<br>");
          }
        },
        { data: "action", name: "action", width: "10rem", className: "dt-left align-top" },
        { data: "why", name: "why", width: "10rem", className: "dt-left align-top" }
    ];
    return returnColumns;
  }

  getMatchVarianceAnalysisResultsTableAttributes(savedCard3Name, savedCard4Name) {
    let returnColumns = [
        { data: "priority", name: "priority", width: "3rem", className: "dt-center align-top" },
        { 
          data: "similarityOrDifference", 
          name: "similarityOrDifference", 
          width: "6rem", 
          className: "dt-left align-top",
          render: function(data, type) {
            if (type !== "display") {
              return data;
            }
            if (data == null) {
              return "";
            }
            const color = data === "Similarity" ? "#BF9000" : "#FF0000";
            return "<span style='color:" + color + ";'>" + data + "</span>";
          }
        },
        { data: "valueSource", name: "valueSource", width: "6rem", className: "dt-left align-top" },
        { data: "keyTakeaway", name: "keyTakeaway", width: "12rem", className: "dt-left align-top" },
        { data: "group1Reasoning", name: "group1Reasoning", width: "15rem", className: "dt-left align-top" },
        { data: "group2Reasoning", name: "group2Reasoning", width: "15rem", className: "dt-left align-top" }
    ];
    if (savedCard3Name && savedCard3Name.trim() !== "") {
      returnColumns.push({
        data: "group3Reasoning",
        name: "group3Reasoning",
        width: "15rem",
        className: "dt-left align-top"
      });
    }

    if (savedCard4Name && savedCard4Name.trim() !== "") {
        returnColumns.push({
          data: "group4Reasoning",
          name: "group4Reasoning",
          width: "15rem",
          className: "dt-left align-top"
        });
    }
    
    return returnColumns;
  }

  getMatchConversionAnalysisResultsTableAttributes() {
    let returnColumns = [
        { data: "priority", name: "priority", width: "3rem", className: "dt-center align-top" },
        { data: "valueSource", name: "valueSource", width: "8rem", className: "dt-left align-top" },
        { data: "keyTakeaway", name: "keyTakeaway", width: "12rem", className: "dt-left align-top" },
        { data: "actionToConvert", name: "actionToConvert", width: "18rem", className: "dt-left align-top" },
        { data: "group1Reasoning", name: "group1Reasoning", width: "15rem", className: "dt-left align-top" },
        { data: "group2Reasoning", name: "group2Reasoning", width: "15rem", className: "dt-left align-top" },
    ];
    return returnColumns;
  }

  getCommentsAITopResultsTableAttributes(includeValueGap = false, isChatGPT = false) {
    let returnColumns = [
        {
          data: "positiveOrNegative",
          name: "positiveOrNegative",
          width: "3rem",
          className: "dt-left align-top",
          render: function(data, type) {
            if (type !== "display") {
              return data;
            }
            if (data == null) {
              return "";
            }
            const color = data === "Positive" ? "#BF9000" : "#FF0000";
            return "<span style='color:" + color + ";'>" + data + "</span>";
          }
        },
        { data: "assignedKeyWord", name: "assignedKeyWord", width: "3rem", className: "dt-left align-top" },
    ];
    if (includeValueGap == true) {
      returnColumns.push(
          { data: "valueGap", name: "valueGap", width: "3rem", className: "dt-left align-top",
              render(v) {
                if (v == null){
                  return " ";
                }
                if (v != null && !isNaN(v)) {
                  return Number(v).toFixed(2);
                } else {
                  return "--";
                }
              }    
          }
      );
    }
    returnColumns.push(
        { data: "themeIdentified", name: "themeIdentified", width: "5rem", className: "dt-left align-top" },
        { data: "description", name: "description", width: "8rem", className: "dt-left align-top" },
        {
          data: "examples",
          name: "examples",
          width: "6rem",
          className: "dt-left align-top",
          render: function (data) {
              if (!Array.isArray(data) || data.length === 0) {
                  return "";
              }
              return data.map(item => `"${item}"`).join(", ");
          }
        }
    );
      returnColumns.push(
          { data: "confidenceScore", name: "confidenceScore", width: "3rem", className: "dt-left align-top" }
      );
    return returnColumns;
  }

  getExploreAITopResultsTableAttributes() {
    return [
        { data: "themeIdentified", name: "themeIdentified", width: "5rem", className: "dt-left align-top" },
        { data: "description", name: "description", width: "8rem", className: "dt-left align-top" },
        {
          data: "examples",
          name: "examples",
          width: "8rem",
          className: "dt-left align-top",
          render: function (data) {
              if (!Array.isArray(data) || data.length === 0) {
                  return "";
              }
              return data.map(item => `"${item}"`).join(", ");
          }
        },
        { data: "confidenceScore", name: "confidenceScore", width: "2rem", className: "dt-left align-top" },
      ]
  }
}
export default new TableService();
